export default __webpack_public_path__ + "static/media/slider-musik.83958dde.png";